import { Component, OnInit,PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
@Pipe({ name: 'safeHtml'})

export class CapitalizePipeComponent implements PipeTransform  {

  constructor(private sanitized: DomSanitizer) { }

  ngOnInit() {
  }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/capitalize-pipe/capitalize-pipe.component.ts